import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Btn, CustomCalendar, CustomInputTextArea, CustomModal } from '../../../../../components'
import { showMessageBox } from '../../../../../store/actions/system.actions'
import { errorHandler } from '../../../../../services/util/error.service'
import * as RetornoHttp from '../../../../../services/api/https/deliveries/retorno.http'

function ModalTentativaReentrega({ show, onModalClose, onModalSave, entrega, readOnly, dispatch }) {
  const [dataHora, setDataHora] = useState(null)
  const [justificativa, setJustificativa] = useState('')
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    if (show && entrega) {
      if (entrega.last_attempt_date) {
        setDataHora(new Date(entrega.last_attempt_date))
      } else {
        setDataHora(null)
      }
      setJustificativa(entrega.last_attempt_justify || '')
    }
  }, [show, entrega])

  const onSalvar = async () => {
    if (!dataHora) {
      dispatch(showMessageBox(null, 'Informe a data e hora da tentativa de reentrega'))
      return
    }

    const pad = n => String(n).padStart(2, '0')
    const formattedDatetime = `${dataHora.getFullYear()}-${pad(dataHora.getMonth() + 1)}-${pad(dataHora.getDate())} ${pad(dataHora.getHours())}:${pad(dataHora.getMinutes())}:00`
    const justificativaValue = justificativa.trim() === '' ? null : justificativa

    setIsLoading(true)
    try {
      await RetornoHttp.putDeliveryEventAttempt(
        entrega.delivery_event_id,
        formattedDatetime,
        justificativaValue,
      )
      dispatch(showMessageBox('Tentativa de reentrega salva com sucesso!', null))
      onModalSave({ ...entrega, last_attempt_date: formattedDatetime, last_attempt_justify: justificativa })
    } catch (error) {
      dispatch(showMessageBox(null, errorHandler(error)))
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <CustomModal
      header="Tentativa de Reentrega"
      isVisible={show}
      onClose={onModalClose}
      width={500}
    >
      <div className="p-grid">
        <div className="p-col-12">
          <CustomCalendar
            label="Data e Hora"
            value={dataHora}
            onChange={value => !readOnly && setDataHora(value)}
            disabled={readOnly}
            marginTop={0}
            showTime
            hourFormat="24"
          />
        </div>
        <div className="p-col-12">
          <CustomInputTextArea
            label="Justificativa"
            value={justificativa}
            onChange={value => !readOnly && setJustificativa(value)}
            disabled={readOnly}
            rows={4}
            marginTop={10}
          />
        </div>
        {!readOnly && (
          <div className="p-col-12" style={{ marginTop: 10 }}>
            <Btn isLoading={isLoading} onClick={onSalvar}>
              Salvar
            </Btn>
          </div>
        )}
      </div>
    </CustomModal>
  )
}

export default connect()(ModalTentativaReentrega)
